﻿import { FunctionComponent } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { NotFound } from "../components/NotFound";
import { AuthorizationCheck } from "../components/AuthorizationCheck";
import { AdminDashboardPage } from "./AdminDashboardPage";
import { AdminUsersPage } from "./AdminUsersPage";
import { AdminUserDetailPage } from "./AdminUserDetailPage";
import { AdminClientsPage } from "./AdminClientsPage";
import { AdminClientDetailPage } from "./AdminClientDetailPage";
import { ClientSelectionPage } from "./ClientSelectionPage";
import { ProfilePage } from "./ProfilePage";
import { UnauthorizedPage } from "./UnauthorizedPage";
import { ClientDashboardPage } from "./ClientDashboardPage";
import { ClientCandidatesPage } from "./ClientCandidatesPage";
import { CandidatePage } from "./CandidatePage";
import { ClientEntitiesPage } from "./ClientEntitiesPage";
import { ClientWageImportsPage } from "./ClientWageImportsPage";
// import { ClientActivityPage } from "./ClientActivityPage";
import { RequestPage } from "./RequestPage";
import { PageWithModal } from "../components/PageWithModal";
import { CandidateDetailsModal } from "./CandidateDetailsPage";
import { RouteGuard } from "../components/RouteGuard";
import { CandidatesArea, DashboardArea, EntitiesArea, WageImportsArea } from "../auth";
import { ApplicationRole } from "../api";

export const PageRoutes: FunctionComponent = () => {
    return (
        <Routes>
            <Route path="" element={<AuthorizationCheck />}>
                <Route index element={<Navigate to="clients" replace />} />
                <Route path="clients">
                    <Route index element={<ClientSelectionPage />} />
                    <Route path=":cId">
                        <Route index element={<RouteGuard securityArea={DashboardArea} render={<ClientDashboardPage />} />} />
                        <Route path="candidates" element={<RouteGuard securityArea={CandidatesArea} render={<ClientCandidatesPage />} />} />
                        <Route
                            path="candidates/:eId/:candidateId"
                            element={<RouteGuard securityArea={CandidatesArea} render={<PageWithModal page={<CandidatePage />} />} />}
                        >
                            <Route path="details" element={<CandidateDetailsModal returnTo={""} />} />
                        </Route>
                        <Route
                            path="candidates/:eId/:candidateId/request"
                            element={<RouteGuard hasAny={[CandidatesArea.request_mgmt]} render={<RequestPage />} />}
                        />
                        <Route path="entities/:entityId?" element={<RouteGuard securityArea={EntitiesArea} render={<ClientEntitiesPage />} />} />
                        <Route path="wage-imports" element={<RouteGuard securityArea={WageImportsArea} render={<ClientWageImportsPage />} />} />
                    </Route>
                </Route>
                <Route path="profile" element={<ProfilePage />} />
                <Route path="admin" element={<AuthorizationCheck requiredRole={ApplicationRole.admin} />}>
                    <Route index element={<AdminDashboardPage />} />
                    <Route path="clients" element={<AdminClientsPage />} />
                    <Route path="clients/:tenantId" element={<AdminClientDetailPage />} />
                    <Route path="clients/:tenantId/:section" element={<AdminClientDetailPage />} />
                    <Route path="users" element={<AdminUsersPage />} />
                    <Route path="users/:userId" element={<AdminUserDetailPage />} />
                    <Route path="users/:userId/:section" element={<AdminUserDetailPage />} />
                </Route>
            </Route>
            <Route path="Unauthorized" element={<UnauthorizedPage />} />
            <Route path="404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};
